import {Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {ActionBase} from './action-base.js';
import {Flashlight} from '../flashlight.js';
import {SoundManagerInstance, Sounds} from '../../managers/soundmanager.js';

export class ActionEnableFlashlight extends ActionBase {
    static TypeName = 'action-enable-flashlight';

    @property.object({required: true})
    flashLightObject!: Object3D;

    @property.bool(true)
    turnOn = true;

    private flashLight!: Flashlight;

    override start() {
        super.start();

        const tempFlashLight = this.flashLightObject.getComponent(Flashlight);
        if (!tempFlashLight) {
            throw new Error(
                `action-enable-flashlight(${this.object.name}): flashLightObject does not have a FlashLight`
            );
        }
        this.flashLight = tempFlashLight;
    }

    override OnTrigger(): void {
        SoundManagerInstance.playSound(Sounds.flashLightOn);
        if (this.turnOn) {
            this.flashLight.turnOn();
        } else {
            this.flashLight.turnOff();
        }
    }
}
